import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useStaffAuth } from '../auth/StaffAuthContext';
import { useAppSession } from '../context/AppSessionContext';
import NotificationBell from './NotificationBell';

export default function Layout({ children, title }: { children: React.ReactNode; title?: string }) {
  const { identity, signOut } = useStaffAuth();
  const { clearProfile } = useAppSession();
  const navigate = useNavigate();

  const logout = async () => {
    await signOut();
    clearProfile();
    navigate('/', { replace: true });
  };

  return (
    <div className="app-shell">
      <header className="topbar">
        <Link to="/dashboard" className="brand" aria-label="Laman utama Kehadiran MTIB">
          <img className="brand-logo" src="/mtib-logo.png" alt="" aria-hidden="true" />
          <span><strong>MTIB</strong><small>Kehadiran</small></span>
        </Link>
        <nav className="nav-links" aria-label="Navigasi utama">
          <NavLink to="/dashboard">Utama</NavLink>
          <NavLink to="/meetings/new">+ Mesyuarat</NavLink>
          <NavLink to="/rooms/calendar">Kalendar Bilik</NavLink>
          {identity.role === 'Admin' && <NavLink to="/admin">Pentadbiran</NavLink>}
        </nav>
        <div className="profile-chip">
          <span className="profile-copy"><strong>{identity.full_name}</strong><small>{identity.department_org ?? 'Bahagian belum ditetapkan'}</small></span>
          <NotificationBell />
          <Link className="button button-ghost button-small" to="/profile">Profil Saya</Link>
          <button className="button button-ghost button-small" onClick={logout}>Log Keluar</button>
        </div>
      </header>
      <main className="page-wrap">
        {title && <div className="page-heading"><h1>{title}</h1></div>}
        {children}
      </main>
    </div>
  );
}
